import { render, staticRenderFns } from "./OakSkillHintPopup.vue?vue&type=template&id=264b6dc4&scoped=true"
import script from "./OakSkillHintPopup.vue?vue&type=script&lang=js"
export * from "./OakSkillHintPopup.vue?vue&type=script&lang=js"
import style0 from "./OakSkillHintPopup.vue?vue&type=style&index=0&id=264b6dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b6dc4",
  null
  
)

export default component.exports